import { useDispatch, useSelector } from "react-redux";
import * as authActions from "./auth.actions";
import * as authSelectors from "./auth.selectors";
export var useDashboardType = function () {
    // Redux
    var dispatch = useDispatch();
    var selectedDashboardType = useSelector(authSelectors.getSelectedDashboardType);
    // Actions
    var setSelectedDashboardType = function (dashboardType) {
        dispatch(authActions.setSelectedDashboardStart.getAction({ dashboardType: dashboardType }));
    };
    return {
        selectedDashboardType: selectedDashboardType,
        setSelectedDashboardType: setSelectedDashboardType,
    };
};
